import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Model } from '../models/model';
import { environment } from '../../../environments/environment';
import { ErosModel } from '../models/eros-model';
import { RequestEros } from '../models/request-eros';
import { RequestModel } from '../models/request-model';
import { RequestCompute } from '../models/request-compute';
import { Forecast } from '../models/forecast';
import { ChartForecastData } from '../models/chart-forecast-data';
import { ErosPrev, ResultPrev } from '../models/eros-prev';
import { ForecastScenario } from '../models/modal-graph-forecast';

@Injectable({
  providedIn: 'root'
})
export class ModelService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getModels(type: string): Observable<Model[]> {
    const params = new HttpParams().set('type', type);
    return this.http.get<Model[]>(`${this.apiUrl}/Model`, { params });
  }

  getResult(identifier: number): Observable<any>{
    return this.http.get<any>(`${this.apiUrl}/Model/${identifier}/results`);
  }

  getLatestResult(identifier: number): Observable<any>{
    return this.http.get<any>(`${this.apiUrl}/Model/${identifier}/results/latest`);
  }

  getErosModels():  Observable<ErosModel[]>{
    return this.http.get<ErosModel[]>(`${this.apiUrl}/Eros`);
  }

  getErosData(id: number): Observable<ErosModel>{
    return this.http.get<ErosModel>(`${this.apiUrl}/Eros/${id}`)
  }

  addErosModel(model: RequestEros): Observable<ErosModel>{
    return this.http.put<ErosModel>(`${this.apiUrl}/Eros`, model);
  }

  updateErosModel(model: RequestEros): Observable<ErosModel>{
    return this.http.patch<ErosModel>(`${this.apiUrl}/Eros`, model);
  }
  
  addModel(model: RequestModel, modelType: string): Observable<Model> {
    return this.http.put<Model>(`${this.apiUrl}/Model/${modelType}`, model);
  }

  updateModel(model: RequestModel, modelType: string): Observable<Model> {
    return this.http.post<Model>(`${this.apiUrl}/Model/${modelType}`, model);
  }

  computeModel(requestCompute: RequestCompute): Observable<ChartForecastData> {
    return this.http.post<ChartForecastData>(`${this.apiUrl}/Model/compute`, requestCompute);
  }

  computeErosModel(requestCompute: RequestCompute): Observable<ResultPrev
  > {
    return this.http.post<ResultPrev>(`${this.apiUrl}/Eros/gardenia9`, requestCompute);
  }

  importManualModelData(id: number, csvContent: string): Observable<any> {
    const formData = new FormData();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    formData.append('csvResult', blob, 'data.csv');

    return this.http.post(`${this.apiUrl}/Model/Manuel/${id}/result`, formData);
  }

  getModelData(id: number): Observable<Model> {
    return this.http.get<Model>(`${this.apiUrl}/Model/${id}`)
  }

  getForecastByResultId(modelId: number, resultId: number): Observable<ForecastScenario[]> {
    return this.http.get<ForecastScenario[]>(`${this.apiUrl}/Model/${modelId}/results/${resultId}`)
  }

  downloadModelResult(modelId: number, resultId: number) {
    const apiRequest = this.http.get(`${this.apiUrl}/Model/${modelId}/results/${resultId}/export.csv`, {responseType: "blob"});
    apiRequest.subscribe(
      (data : Blob) => {
        this.launchDownloadFile(data, `export_model_${modelId}.csv`)
      },
    );
  }

  public launchDownloadFile(blob:Blob, fileName:string) {
    const link = window.document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }

  public getLastDate(modelData: any): Date | null {
    let mostRecentDate: Date | null = null;
  
    modelData.forEach((sensor: { SensorType: string; result: any[]; }) => {
      if (sensor.SensorType === "Piezo") {
        sensor.result[0].forEach((element: { date: string; }) => {
          const currentDate = new Date(element.date);
          if (!mostRecentDate || currentDate > mostRecentDate) {
            mostRecentDate = currentDate;
          }
        });
      }
    });
    
    return mostRecentDate;
  }
}
